export const GIT_COMMIT = 'f055c7394763c8f0e88e346b9b219cd87e81aabd'
